import { useEffect, useState } from "react";
import { getGroupMasters, saveStudent } from "../../services/studentService";

const GROUP_ID = "AABFXWN";

const StudentModal = ({ onClose }) => {
  const [masters, setMasters] = useState([]);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  const [parentName, setParentName] = useState("");
  const [parentPhone, setParentPhone] = useState("");
  const [studentName, setStudentName] = useState("");

  const [branchId, setBranchId] = useState("");
  const [courseId, setCourseId] = useState("");
  const [branchCourseId, setBranchCourseId] = useState("");
  const [batchId, setBatchId] = useState("");

  const [fees, setFees] = useState("");
  const [joinDate, setJoinDate] = useState("");

  useEffect(() => {
    const fetchMasters = async () => {
      try {
        const data = await getGroupMasters(GROUP_ID);
        setMasters(data || []);
      } catch (err) {
        console.error("Failed to fetch masters", err);
      } finally {
        setLoading(false);
      }
    };

    fetchMasters();
  }, []);

  /* ---------- Dropdown Data ---------- */
  const branches = [
    ...new Map(
      masters.map((i) => [
        i.BranchId,
        { id: i.BranchId, name: i.BranchName },
      ])
    ).values(),
  ];

  const courses = [
    ...new Map(
      masters
        .filter((i) => i.BranchId === branchId)
        .map((i) => [
          i.CourseId,
          {
            CourseId: i.CourseId,
            CourseName: i.CourseName,
          },
        ])
    ).values(),
  ];

  const batches = masters.filter(
    (i) => i.BranchId === branchId && i.CourseId === courseId
  );

  /* ---------- Reset ---------- */
  useEffect(() => {
    setCourseId("");
    setBatchId("");
    setBranchCourseId("");
  }, [branchId]);

  useEffect(() => {
    setBatchId("");
    setBranchCourseId("");
  }, [courseId]);

  /* ---------- Save Student ---------- */
  const handleSave = async () => {
    if (!parentPhone || !studentName) {
      alert("Student Name & Parent Mobile are required");
      return;
    }

    if (!branchId || !courseId || !batchId || !fees || !joinDate) {
      alert("Please select Branch, Course, Batch, Fees and Join Date");
      return;
    }

    // ✅ Derive BranchCourseId safely
    const selectedBranchCourse = masters.find(
      (m) =>
        m.BranchId === branchId &&
        m.CourseId === courseId
    );

    if (!selectedBranchCourse?.BranchCourseId) {
      alert("Invalid Branch / Course selection");
      return;
    }

    const payload = {
      rows: [
        {
          parentName: parentName.trim() || "",
          parentPhone,
          studentName,
          branchCourseId: selectedBranchCourse.BranchCourseId,
          batchId,
          fees: Number(fees),
          joinDate,
        },
      ],
    };

    console.log("Save Student Payload 👉", payload);

    try {
      setSaving(true);
      await saveStudent(payload);
      alert("Student saved successfully");
      onClose();
    } catch (err) {
      console.error("Save failed", err);
      alert(typeof err === "string" && err ? err : "Failed to save student");
    } finally {
      setSaving(false);
    }
  };


  if (loading) {
    return (
      <div className="modal-backdrop">
        <div className="modal-card">Loading...</div>
      </div>
    );
  }

  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div
        className="modal-card"
        onClick={(e) => e.stopPropagation()}
      >

        <h3>Add Student</h3>

        <div className="form-grid">
          <input
            placeholder="Parent Name (Optional)"
            value={parentName}
            onChange={(e) => setParentName(e.target.value)}
          />

          <input
            placeholder="Mobile"
            value={parentPhone}
            onChange={(e) => setParentPhone(e.target.value)}
          />

          <input
            placeholder="Student Name"
            value={studentName}
            onChange={(e) => setStudentName(e.target.value)}
          />

          {/* Branch */}
          <select value={branchId} onChange={(e) => setBranchId(e.target.value)}>
            <option value="">Select Branch</option>
            {branches.map((b) => (
              <option key={b.id} value={b.id}>
                {b.name}
              </option>
            ))}
          </select>

          {/* Course */}
          <select
            value={courseId}
            disabled={!branchId}
            onChange={(e) => {
              const selected = courses.find(
                (c) => c.CourseId === e.target.value
              );
              setCourseId(e.target.value);
              setBranchCourseId(selected?.BranchCourseId || "");
            }}
          >
            <option value="">Select Course</option>
            {courses.map((c) => (
              <option key={c.CourseId} value={c.CourseId}>
                {c.CourseName}
              </option>
            ))}
          </select>

          {/* Batch */}
          <select
            value={batchId}
            disabled={!courseId}
            onChange={(e) => setBatchId(e.target.value)}
          >
            <option value="">Select Batch</option>
            {batches.map((b) => (
              <option key={b.BatchId} value={b.BatchId}>
                {b.BatchName} ({b.BatchTime})
              </option>
            ))}
          </select>

          <input
            type="number"
            placeholder="Fees"
            value={fees}
            onChange={(e) => setFees(e.target.value)}
          />

          <input
            type="date"
            value={joinDate}
            onChange={(e) => setJoinDate(e.target.value)}
          />
        </div>

        <div className="modal-actions">
          <button onClick={onClose}>Cancel</button>
          <button
            className="primary-btn"
            onClick={handleSave}
            disabled={saving}
          >
            {saving ? "Saving..." : "Save"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default StudentModal;
